import { useEffect, useState } from "react";
import { useGetMedicalProviders } from "../../../../redux/reduxQuery/medicalProviderApi";
import { useAsyncConfig } from "../../../../components/organisms/CustomTable";

interface AsyncConfigFacets {
  search?: string;
}

interface AsyncConfig {
  facets?: AsyncConfigFacets;
  pageSize?: number;
  pageIndex?: number;
  sort?: unknown[];
  onSortingChange?: (sort: unknown[]) => void;
  onPaginationChange?: (pagination: {
    pageIndex: number;
    pageSize: number;
  }) => void;
}

export interface TableConfig {
  loading?: boolean;
  data?: unknown[];
  asyncConfig?: AsyncConfig;
}

export const useGetData = (initialQs = "", pageSize = 50) => {
  const [dataToFetch, setDataToFetch] = useState(initialQs);
  const getData = useGetMedicalProviders(dataToFetch);
  const [config, refetch] = useAsyncConfig(getData, pageSize);
  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataToFetch]);
  return {
    config: config as TableConfig,
    refetch,
    dataToFetch,
    setDataToFetch,
  };
};
